export default {
  namespaced: true,

  state: {
    shows: false,
    /** 검색키, 키가 갱신된 경우 동일한 검색조건에서도 다시 검색을 수행 */
    key: Date.now(),
    defaultKeyword: '',
  },

  mutations: {
    SET_SHOWS: (state, shows) => {
      state.shows = shows;
    },
    INCREASE_KEY: (state) => {
      state.key += state.key;
    },
    SET_DEFAULT_KEYWORD: (state, defaultKeyword) => {
      state.defaultKeyword = defaultKeyword;
    },
  },

  actions: {
    openFinder({ commit }, { defaultKeyword = '' } = {}) {
      commit('SET_DEFAULT_KEYWORD', defaultKeyword);
      commit('SET_SHOWS', true);
    },
    closeFinder({ commit }) {
      commit('SET_SHOWS', false);
    },
    toggleFinder({ commit, state }) {
      commit('SET_SHOWS', state.shows);
    },
    increaseKey({ commit }) {
      commit('INCREASE_KEY');
    },
  },

  getters: {
    showsFinder: (state) => state.shows,
    searchKey: (state) => state.key,
    defaultKeyword: (state) => state.defaultKeyword,
  },
};
